<div class="orgApp-nacs-container orgApp-justify-c-center orgApp-d-flex"
    >
    <div class="orgApp-d-flex orgApp-flex-dir-col" >
        <div class="orgApp-d-flex orgApp-justify-c-center" >
            <div class="orgApp-d-flex orgApp-text-left orgApp-justify-c-center orgApp-flex-dir-col orgApp-gap-32">
                <div class="orgApp-d-flex orgApp-text-left orgApp-justify-c-center orgApp-flex-dir-col orgApp-gap-16">
                    <h2 class="orgApp-margin-top-0 orgApp-margin-bottom-0">{{title | translate}}</h2>
                    <p class="orgApp-margin-top-0 orgApp-margin-bottom-0 orgApp-nacs-subtitle">   {{ message | translate }}</p>
                </div>
                <button mat-stroked-button class="orgApp-nacs-h-btn" [routerLink]="isLoggedIn ? '/dashboard' : '/'">
                    {{"no-access.action.back_to_home" | translate}}
                </button>
            </div>
        </div>
    </div>
</div>